import { useMemo } from "react";
import { appShellMetrics } from "./spacing";

export type AppNavigationLabel = { name: string; depth: number; hasChildren: boolean };

/** Size navigation from translated labels, preserving the existing text measurement. */
export function useAppNavigationWidth(labels: AppNavigationLabel[]): number {
  return useMemo(() => {
    const fallback = (value: string) => value.length * appShellMetrics.navigationAverageCharacterWidth;
    const context = typeof document === "undefined" ? null : document.createElement("canvas").getContext("2d");
    if (context) {
      const style = window.getComputedStyle(document.body);
      context.font = `${style.fontWeight || "400"} ${style.fontSize || "14px"} ${style.fontFamily || "Arial"}`;
    }
    const measure = context ? (value: string) => Math.ceil(context.measureText(value).width) : fallback;
    const required = labels.reduce((width, item) => Math.max(width,
      appShellMetrics.navigationIndent * (item.depth + 1)
      + appShellMetrics.navigationIconWidth + measure(item.name)
      + appShellMetrics.navigationItemGutter
      + (item.hasChildren ? appShellMetrics.navigationArrowWidth : 0)
      + appShellMetrics.navigationTextSafetyPadding), 0);
    return Math.max(appShellMetrics.navigationMinWidth, Math.min(appShellMetrics.navigationMaxWidth, required));
  }, [labels]);
}
